export enum MoveTransactionType {
    Sale = 'sale',
    Rental = 'rental',
}

export enum TransactionType {
    Sale = 'sale',
    Rental = 'rental',
}
